import React, { useEffect, useRef, useState } from 'react'
import * as S from '../styles/select-style'
import { ServiceToAddType } from '../Modals/ViewPCP/AddServiceModal'

interface SelectAndSearchProps {
  label: string
  options: Partial<ServiceToAddType>[]
  onSelect: (option: Partial<ServiceToAddType>) => void
  selectedOption?: {id: number, name: string}
}

const SelectAndSearch:React.FC<SelectAndSearchProps> = ({label, options, onSelect, selectedOption}) => {
  const [showOptions, setShowOptions] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)

  const handleSelectOption = (option: Partial<ServiceToAddType>) => {
    setSelectedIndex(0)
    onSelect(option)
    setShowOptions(false)
  }

  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < options.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectOption(options[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  const handleBlur = () => {
    setTimeout(() => {
      setShowOptions(false)
    }, 250) // esse delay é para permitir o clique na opção
  }
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  
  return (
    <S.InputDiv>
      <S.Label>{label}</S.Label>
      <S.Input autoComplete='off' type='text' placeholder='Digite aqui' value={selectedOption?.name} ref={inputRef} onFocus={() => setShowOptions(true)} onBlur={handleBlur} onKeyDown={handleSetOptionByKey} />
      {showOptions && (
        <S.SearchOptions ref={optionsRef}>
          {options.map((option, index) => (
            <S.Option
              key={index} 
              onClick={() => handleSelectOption(option)}
              isSelected={index === selectedIndex}
            > {option.name}
            </S.Option>
          ))}
        </S.SearchOptions>
      )}
    </S.InputDiv>
  )
}

export default SelectAndSearch